import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Send, ExternalLink } from "lucide-react";

/** Card that loads the Telegram group URL for active participants. */
export default function TelegramGroupCard({ variant = "default" }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/community/telegram");
        setUrl(data.url);
      } catch (err) {
        setError(err?.response?.data?.detail || "Tidak dapat memuat link group.");
      }
    })();
  }, []);

  if (error || !url) return null;

  const compact = variant === "compact";

  return (
    <div
      className={`rounded-xl border border-amber-500/30 bg-gradient-to-br from-amber-500/10 via-amber-500/5 to-transparent ${compact ? "p-4" : "p-6"}`}
      data-testid="telegram-card"
    >
      <div className="flex items-start gap-4 flex-wrap">
        <div className={`shrink-0 ${compact ? "w-10 h-10" : "w-12 h-12"} rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center`}>
          <Send className="text-amber-400" size={compact ? 18 : 22} />
        </div>
        <div className="flex-1 min-w-[200px]">
          <div className={`font-display font-bold ${compact ? "text-base" : "text-xl"}`}>
            Group Support Ahli
          </div>
          <p className="text-sm text-neutral-400 mt-1">
            Sertai komuniti Face Club di Telegram. Dapatkan bantuan, kongsi karya, dan tips daripada ahli lain.
          </p>
        </div>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-amber-500 text-black font-semibold hover:bg-amber-400 transition-colors text-sm"
          data-testid="telegram-join-btn"
        >
          <Send size={14} /> Sertai Telegram <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
